import React from 'react';

const Loading = () => {
    return (
        <div className='text-center min-h-screen flex align-middle justify-center items-center'>
            <button className="btn loading btn-secondary text-white">loading</button>
        </div>
    );
};

export default Loading;